<app-simulation-view
  class="simulation-view"
  #simulationDetails3DView
  [id]="loadinfo.id"
  [urdfURL]="loadinfo.urdfURL"
  [customerOrgWallSticker]="(stickers$ | async)?.customerOrgWallSticker"
  [salesOrgWallSticker]="(stickers$ | async)?.salesOrgWallSticker"
  [boxSticker]="(stickers$ | async)?.box"
  [labelOrientation]="labelOrientation"
  [movementBoxes]="selectedMovementBoxes"
  [productModelId$]="productModelId$"
  [isOpen]="isOpen"
></app-simulation-view>

<app-rosbag-player
  class="rosbag-player"
  *ngIf="loadinfo?.bagURL"
  id="rosbag-player"
  [url]="loadinfo.bagURL"
  [disabled]="(simulationDetails3DView.loading$ | async)?.value"
  [movementBoxOptions]="movementBoxOptions"
  [playerMode]="playerMode"
  (playerModeEvent)="playerModeEvent.emit($event)"
  (selectedMovementBox)="setSelectedMovementBox($event)"
></app-rosbag-player>
